try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@design-system/error-message';
import { FieldHead } from '@design-system/field-head';
import { Icon } from '@design-system/icon';
import { DangerouslySetInnerHtml } from '@phx-husky/dangerously-set-inner-html';
import classNames from 'classnames';
import { forwardRef, useCallback } from 'react';
import Select, { components } from 'react-select';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const RenderHtmlLabel = ({ label }) => (jsx(DangerouslySetInnerHtml, { html: label || '' }));
const Dropdown = forwardRef((_a, ref) => {
    var { className, id, label, placeholder, description, errorMessage, tooltipLabel, tooltipText, value, onChange, name, options, isClearable, isDisabled, isMulti = false } = _a, rest = __rest(_a, ["className", "id", "label", "placeholder", "description", "errorMessage", "tooltipLabel", "tooltipText", "value", "onChange", "name", "options", "isClearable", "isDisabled", "isMulti"]);
    const Option = useCallback((props) => {
        var _a;
        const { isSelected, data } = props;
        return (jsxs(components.Option, Object.assign({}, props, { children: [jsx(RenderHtmlLabel, { label: (_a = data.label) === null || _a === void 0 ? void 0 : _a.toString() }), isSelected && (jsx(Icon, { size: 10, className: "cds-dropdown__selected-icon", icon: "checkmark" }))] })));
    }, []);
    const SingleValue = useCallback((props) => {
        var _a;
        return (jsx(components.SingleValue, Object.assign({}, props, { children: jsx(RenderHtmlLabel, { label: (_a = props.data.label) === null || _a === void 0 ? void 0 : _a.toString() }) })));
    }, []);
    const MultiValue = useCallback((props) => {
        var _a;
        return (jsx(components.MultiValue, Object.assign({}, props, { children: jsx(RenderHtmlLabel, { label: (_a = props.data.label) === null || _a === void 0 ? void 0 : _a.toString() }) })));
    }, []);
    return (jsxs("div", Object.assign({ className: classNames('cds-dropdown', className), ref: ref }, { children: [jsx(FieldHead, { id: id, label: label, description: description, tooltipLabel: tooltipLabel, tooltipText: tooltipText }), jsx(Select, Object.assign({ components: { Option, SingleValue, MultiValue }, className: classNames('cds-dropdown__select', {
                    'cds-dropdown__select--error': Boolean(errorMessage),
                }), classNamePrefix: "cds-dropdown__select", styles: {
                    control: (_a) => {
                        var provided = __rest(_a, ["outline"]);
                        return provided;
                    },
                }, id: id, name: name, onChange: onChange, options: options, value: value, placeholder: placeholder || null, isClearable: isClearable, isDisabled: isDisabled, isMulti: isMulti, tabSelectsValue: false }, rest)), jsx(ErrorMessage, { message: errorMessage })] })));
});

export { Dropdown };
